import { render, staticRenderFns } from "./BlogManageCommnets.vue?vue&type=template&id=302c409f"
import script from "./BlogManageCommnets.vue?vue&type=script&lang=js"
export * from "./BlogManageCommnets.vue?vue&type=script&lang=js"
import style0 from "./BlogManageCommnets.vue?vue&type=style&index=0&id=302c409f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports